import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-linkedn',
  templateUrl: './icon-linkedn.component.html',
  styles: []
})
export class IconLinkednComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
